import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { athleteMe, athleteLogin, athleteLogout } from "./api";

const AthleteAuthContext = createContext(null);

export function AthleteAuthProvider({ children }) {
  const [athlete, setAthlete] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await athleteMe();
      setAthlete(data);
    } catch {
      setAthlete(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const res = await athleteLogin(email, password);
    setAthlete(res.athlete);
    return res;
  };

  const logout = async () => {
    try {
      await athleteLogout();
    } finally {
      setAthlete(null);
    }
  };

  return (
    <AthleteAuthContext.Provider value={{ athlete, loading, login, logout, refresh, setAthlete }}>
      {children}
    </AthleteAuthContext.Provider>
  );
}

export function useAthleteAuth() {
  const ctx = useContext(AthleteAuthContext);
  if (!ctx) throw new Error("useAthleteAuth must be used within AthleteAuthProvider");
  return ctx;
}
